import PropTypes from 'prop-types'
import React from 'react'
import { useFormContext } from 'react-hook-form'

const ChoiceOption = ({
  type = 'checkbox',
  value,
  children,
  name,
  hasError,
  required = false,
  style,
}) => {
  const { register } = useFormContext()
  const rest = {}
  if (name) {
    Object.assign(
      rest,
      register(name, {
        required,
      })
    )
  }
  return (
    <label className='input-block checkbox mb-24' style={style}>
      <input
        className='form-radio checkbox__input'
        type={type}
        value={value}
        name={name}
        {...rest}
      />
      <span
        className={`checkbox__fake contact-form__checkbox ${hasError &&
          'checkbox__input_err'}`}
      >
        <svg width='10' height='10' viewBox='0 0 10 10'>
          <polyline points='2,5 4,7 8,3' />
        </svg>
      </span>
      <span className='checkbox__label contact-form__label contact-form__label--checbox'>
        {children}
      </span>
    </label>
  )
}

ChoiceOption.propTypes = {
  children: PropTypes.node,
  value: PropTypes.string,
  name: PropTypes.string,
  type: PropTypes.string,
  hasError: PropTypes.bool,
  required: PropTypes.bool,
  style: PropTypes.object,
}

export default ChoiceOption
